import { Component, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'context-menu',
    templateUrl: 'contextMenu.component.html',
    styleUrls: ['contextMenu.component.css'],
    host: {'(document:click)': 'clickedOutside()' }
})

export class ContextMenuComponent {
    items: string[] = [];
    isShown = false;
    private mouseLocation: { left: number, top: number } = { left: 0, top: 0 };

    @Output() itemClick = new EventEmitter<string>();

    // the css for the container div
    get locationCss() {
        return {
            'position': 'fixed',
            'display': this.isShown ? 'block' : 'none',
            left: this.mouseLocation.left + 'px',
            top: this.mouseLocation.top + 'px'
        };
    }

    clickedOutside() {
        this.isShown = false; // hide the menu
    }

    // show the menu and set the location of the mouse
    showMenu(event, items) {
        this.isShown = true;
        this.items = items;
        this.mouseLocation = {
            left: event.clientX,
            top: event.clientY
        }
    }

    onClick(item) {
        this.itemClick.emit(item.text);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ContextMenu/contextMenu.component.ts